import React, { useContext, useEffect, useState } from 'react'
import './statistiquesAujourdhui.css'
import Label from '../../../svg/Label'
import { StatistiqueContext } from '../../../context/statistiqueContext/StatistiqueContext';
import ErrorComponent from '../../../components/errorComponent/ErrorComponent';
import LoadingComponent from '../../../components/loadingComponent/LoadingComponent';
import { getStatistiques } from '../../../context/statistiqueContext/apiCalls'
// import { typeMovements, wilayas } from '../../../data';
// import { AgenceContext } from '../../../context/agenceContext/AgenceContext';
// import { getAgencesByWilaya } from '../../../context/agenceContext/apiCalls';
// import { AuthContext } from '../../../context/authContext/AuthContext';

function StatistiquesAujourdhui() {
    const { dispatch, statistiques, isFetchingGet, errorGet } = useContext(StatistiqueContext);

    useEffect(() => {
        getStatistiques(dispatch);
    }, [])

    return (
        <div className='statistiques'>
            {
                errorGet ? <ErrorComponent error={errorGet} /> : (
                    isFetchingGet ? <LoadingComponent /> : (
                        <>
                            {/* Nombre d'Envois Par Action */}
                            <div className='statistiques-title'>
                                <Label widthSize="35px" heightSize='17px' />
                                <span>Nombre d'Envois Par Action :</span>
                            </div>
                            <div className='statistiques-boxes'>
                                <div className='statistiques-box'>
                                    <span className="statistiques-sub-title preparation">Preparation</span>
                                    <div className="statistiques-sub-detail">
                                        <div>
                                            <span>Aujourdui'hui</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionD"] && statistiques["envoisActionD"].filter(item => item.type === 10)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                        <div>
                                            <span>Mois En Cours</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionM"] && statistiques["envoisActionM"].filter(item => item.type === 10)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                        <div>
                                            <span>Global</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionG"] && statistiques["envoisActionG"].filter(item => item.type === 10)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='statistiques-box'>
                                    <span className="statistiques-sub-title ramassage">Ramassage</span>
                                    <div className="statistiques-sub-detail">
                                        <div>
                                            <span>Aujourdui'hui</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionD"] && statistiques["envoisActionD"].filter(item => item.type === 1)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                        <div>
                                            <span>Mois En Cours</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionM"] && statistiques["envoisActionM"].filter(item => item.type === 1)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                        <div>
                                            <span>Global</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionG"] && statistiques["envoisActionG"].filter(item => item.type === 1)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='statistiques-box'>
                                    <span className="statistiques-sub-title reception-agence">Réception Agence</span>
                                    <div className="statistiques-sub-detail">
                                        <div>
                                            <span>Aujourdui'hui</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionD"] && statistiques["envoisActionD"].filter(item => item.type === 8)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                        <div>
                                            <span>Mois En Cours</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionM"] && statistiques["envoisActionM"].filter(item => item.type === 8)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                        <div>
                                            <span>Global</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionG"] && statistiques["envoisActionG"].filter(item => item.type === 8)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='statistiques-box'>
                                    <span className="statistiques-sub-title depot-agence">Dépot Client</span>
                                    <div className="statistiques-sub-detail">
                                        <div>
                                            <span>Aujourdui'hui</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionD"] && statistiques["envoisActionD"].filter(item => item.type === 2)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                        <div>
                                            <span>Mois En Cours</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionM"] && statistiques["envoisActionM"].filter(item => item.type === 2)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                        <div>
                                            <span>Global</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionG"] && statistiques["envoisActionG"].filter(item => item.type === 2)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='statistiques-box'>
                                    <span className="statistiques-sub-title acheminement-depart">Dispatch</span>
                                    <div className="statistiques-sub-detail">
                                        <div>
                                            <span>Aujourdui'hui</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionD"] && statistiques["envoisActionD"].filter(item => item.type === 3)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                        <div>
                                            <span>Mois En Cours</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionM"] && statistiques["envoisActionM"].filter(item => item.type === 3)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                        <div>
                                            <span>Global</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionG"] && statistiques["envoisActionG"].filter(item => item.type === 3)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='statistiques-box'>
                                    <span className="statistiques-sub-title acheminement-arrive">Centre</span>
                                    <div className="statistiques-sub-detail">
                                        <div>
                                            <span>Aujourdui'hui</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionD"] && statistiques["envoisActionD"].filter(item => item.type === 4)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                        <div>
                                            <span>Mois En Cours</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionM"] && statistiques["envoisActionM"].filter(item => item.type === 4)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                        <div>
                                            <span>Global</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionG"] && statistiques["envoisActionG"].filter(item => item.type === 4)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='statistiques-box'>
                                    <span className="statistiques-sub-title stock-agence">Stock Agence</span>
                                    <div className="statistiques-sub-detail">
                                        <div>
                                            <span>Aujourdui'hui</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionD"] && statistiques["envoisActionD"].filter(item => item.type === 9)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                        <div>
                                            <span>Mois En Cours</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionM"] && statistiques["envoisActionM"].filter(item => item.type === 9)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                        <div>
                                            <span>Global</span>
                                            <span>
                                                {
                                                    statistiques["envoisActionG"] && statistiques["envoisActionG"].filter(item => item.type === 9)[0]['countByAction']
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                )
            }
        </div >
    )
}

export default StatistiquesAujourdhui